
import React, {useState, useEffect} from "react";
import { BASE_URL } from "../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Row, Col, Container, Card, Button, } from 'react-bootstrap';
import '../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Institute_Master = () => {

//  const [sctyData, setSctData] = useState([]);

  const [formData, setFormData] = useState({
    inst_id: '',
    inst_name: '',
    trust_name: '',
    curr_acad_st_date: '',
    curr_acad_end_date: '',
    regn_no: '',
    addr_1: '',
    addr_2: '',
    addr_3: '',
    tel_no: '',
    email_id: '',
    password: '',
    re_enter_password: '',
    web_site: '',
    // off_time_wkdays_even_to: '',
    // off_time_holi_fr: '',
    // off_time_holi_to: '',
  });

  useEffect(() => {
      const fetchData = async () => {
        try {

          const response = await axios.get(`${BASE_URL}/api/get_institute_details`);
          const data = response.data[0];

          if (data) {
            setIsEditable(true);
            setFormData(prev => ({ ...prev, ...data }));
          }
        } catch (error) {
          console.error('Error fetching Society Data:', error);
        }
      };

      fetchData();

  }, []);

  const [isEditable, setIsEditable] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      if (!formData.inst_name)
      {
        toast.error('Please enter Institute Name.');
        return;
      }
      else if (!formData.addr_1) {
        toast.error('Please enter Address line 1.');
        return;
      }

      const isConfirmed = window.confirm("Sure you want to update the record ?");

      if (!isConfirmed) {
        return;
      }

      const response = await axios.post(`${BASE_URL}/api/update_mst_institutes`, formData);

      if (response.data.message === '1'){
        toast.success('Institute details updated successfully.');
      }

     // setIsEditable(false);
    }
    catch (error) {
      toast.error('Institute update error !', error);

    }
  };

  return (
    <Container fluid className="p-3">
      <Card style={{ marginTop: '10px', padding: '15px' }}>
        <Row className="mb-3">

          <Col md={4}>
            <label> Institute Name: </label>
            <input
              type="text"
              className="form-control"
              name="inst_name"
              value={formData.inst_name}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col>

          <Col md={4}>
            <label> Trust Name: </label>
            <input
              type="text"
              className="form-control"
              name="trust_name"
              value={formData.trust_name}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col>

          <Col md={2}>
            <label> Start Academic Year: </label>
            <input
              type="text"
              className="form-control"
              name="curr_acad_st_date"
              value={formData.curr_acad_st_date}
              onChange={handleChange}
              disabled
            />
          </Col>

           <Col md={2}>
            <label> End Academic Year</label>
            <input
              type="text"
              className="form-control"
              name="curr_acad_end_date"
              value={formData.curr_acad_end_date}
              onChange={handleChange}
              disabled
            />
          </Col>

        </Row>

        <Row className="mb-3">
         
          <Col md={4}>
            <label> Registration Number:</label>
            <input
              type="text"
              className="form-control"
              name="regn_no"
              value={formData.regn_no}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col>
          <Col md={4}>
            <label> Telephone Number </label>
            <input
              type="number"
              className="form-control"
              name="tel_no"
              value={formData.tel_no}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col>

          <Col md={4}>
            <label> Website: </label>
            <input
              type="text"
              className="form-control"
              name="web_site"
              value={formData.web_site}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col>
        </Row>


        <Row className="mb-3">

          <Col md={4}>
            <label> Address Line 1:</label>
            <input
              type="text"
              className="form-control"
              name="addr_1"
              value={formData.addr_1}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col>

          <Col md={4}>
            <label> Address Line 2: </label>
            <input
              type="text"
              className="form-control"
              name="addr_2"
              value={formData.addr_2}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col>
          <Col md={4}>
            <label> Address Line 3: </label>
            <input
              type="text"
              className="form-control"
              name="addr_3"
              value={formData.addr_3}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col>

          
        </Row>

        <Row className="mb-3">

          <Col md={4}>
            <label> E-Mail: </label>
            <input
              type="email"
              className="form-control"
              name="email_id"
              value={formData.email_id}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col>
          {/* <Col md={4}>
            <label> Password: </label>
            <input
              type="text"
              className="form-control"
              name="password"
              value={formData.password}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col>
          <Col md={4}>
            <label> Re-Enter Password: </label>
            <input
              type="text"
              className="form-control"
              name="re_enter_password"
              value={formData.re_enter_password}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col> */}

        </Row>

        <Row className="mb-3 justify-content-end">
          <Col md="auto">
            <button className="btn btn-success" style={{ width: "100px" }} onClick={handleSave} disabled={!isEditable}>Save</button>
          </Col>
        </Row>
      </Card>

    </Container>
  );
};

export default Institute_Master;
